<template>
    <div class="mission-layer" keep-alive>
        <div class="mask" :class="isShow?'mask-show':'mask-hide'" @click="panelHide"></div>
        <div class="mission-panel" :class="isShow?'panel-show':'panel-hide'">
            <div class="mission-panel-head">
                <div class="mission-panel-title">完成任务，就会下蛋哦</div>
                <div class="mission-panel-subtitle">只有从游戏里去完成任务才能领奖哦！</div>
                <div class="mission-close-icon" @click="panelHide"
                     clstag="A05R|101449"></div>
            </div>
            <div class="mission-body" ref="wrapper">
                <div class="mission-scroller">
                    <div class="mission-item" v-for="(item,index) in missionList" :key="item.missionId">
                        <div class="mission-icon">
                            <!-- <img :src="item.icon" class="pct100"> -->
                            <JrmcBaseImg :src="item.icon" class="pct100"></JrmcBaseImg>
                        </div>
                        <div class="mission-des">
                            <div class="mission-item-title">{{item.name}}</div>
                            <div class="mission-item-detail">{{item.detail}}</div>
                        </div>
                        <div class="mission-btn-box">
                            <div class="mission-item-reward">
                                <div class="reward-icon"></div>
                                <div class="reward-num udc-bold">+{{item.awards[0].awardNum}}</div>
                                <!--<div class="reward-unit">{{item.awards[0].awardUnit}}</div>-->
                            </div>

                            <div class="mission-btn btn-todo" v-if="item.status==0"
                                 clstag="A05R|clk_taskpage"
                                 :data-qidian-ext="
                                    JSON.stringify({
                                        channel: 'ttte',
                                        channelName: 'ttte',
                                        missionid: item.missionId,
                                        missionName: item.name,
                                        serid: '进行中',
                                    })
                                    "
                                 @click="jumpUrl(item.missionId,item.doLink)">去完成
                            </div>
                            <div class="mission-btn btn-todo" v-if="item.status==-1"
                                 clstag="A05R|clk_taskpage"
                                 :data-qidian-ext="
                                    JSON.stringify({
                                        channel: 'ttte',
                                        channelName: 'ttte',
                                        missionid: item.missionId,
                                        missionName: item.name,
                                        serid: '等待接取',
                                    })
                                    "
                                 @click="getMissionAndJump(item.missionId,item.doLink,item.missionType)">去完成
                            </div>
                            <div class="mission-btn btn-get-reward" v-if="item.status==1"
                                 :clstag="item.missionType==2?'A05R|128995':'A05R|101448'"
                                 :data-qidian-ext="
                                    JSON.stringify({
                                        channel: 'ttte',
                                        channelName: 'ttte',
                                        missionid: item.missionId,
                                        missionName: item.name,
                                        serid: '已完成待领奖',
                                    })
                                    "
                                 @click="getReward(item.missionId,item.awards[0].awardNum,index,item.missionType)">领奖励
                            </div>
                            <div class="mission-btn btn-finish" v-if="item.status==2"
                            :clstag="item.missionType==2?'A05R|128994':'A05R|106597'"
                                 :data-qidian-ext="
                                    JSON.stringify({
                                        channel: 'ttte',
                                        channelName: 'ttte',
                                        missionid: item.missionId,
                                        missionName: item.name,
                                        serid: '已完成已领奖',
                                    })
                                    " @click="getReward2(item.missionType,item.doLinkAward)">{{item.missionType==2?'回小金库':'已完成'}}</div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<style rel="stylesheet/scss" lang="scss">
    .mission-layer { position: fixed; left: 0; top: 0; width: 100%; height: 100%; z-index: 30;
        .mask { position: absolute; left: 0; top: 0; bottom: 0; right: 0; margin: auto; width: 100%; height: 100%; background: rgba(0, 0, 0, 0.8); }
        .mission-panel { height: 5rem; width: 100%; position: absolute; bottom: 0; overflow: hidden; }
        .mask-show { animation: maskShow 0.3s 1 ease-out both; }
        .mask-hide { animation: maskHide 0.3s 1 ease-out both; }
        .panel-show { animation: panelShow 0.3s 1 ease-out both; }
        .panel-hide { animation: panelHide 0.3s 1 ease-out both; }
        .mission-panel-head { width: 100%; height: 0.7rem; background: url(#{$path}/home/mission-panel-head.png) no-repeat center top; background-size: 100% 100%; }
        .mission-body { width: 100%; height: 4.31rem; background: #fff; overflow: hidden; margin-top: -0.01rem; }
        .mission-panel-title { color: #444; font-size: 0.18rem; font-weight: bold; text-align: left; padding-top: 0.2rem; margin-left: 0.15rem; line-height: 1; }
        .mission-panel-subtitle { color: #969696; font-size: 0.12rem; text-align: left; margin-top: 0.08rem; margin-left: 0.15rem; line-height: 1; }

        .mission-close-icon { width: 0.48rem; height: 0.48rem; background: url(#{$path}/home/mission-panel-close.png) no-repeat center center; @include singleBg;position: absolute; right: 0; top: 0.2rem; }

        //mission-item
        .mission-scroller { padding: 0.1rem 0.1rem 0.45rem 0.1rem;}
        .mission-item { height: 0.85rem; background-image: linear-gradient(225deg, #803DFB 0%, #3450E6 100%); border-radius: 0.05rem; margin-bottom: 0.1rem; display: flex; align-items: center; justify-content: space-between; padding-left: 0.12rem; padding-right: 0.12rem; }
        .mission-icon { width: 0.45rem; height: 0.45rem; }
        .mission-des { width: 2rem; text-align: left; color: #fff; line-height: 0.26rem; }
        .mission-item-title { white-space: nowrap;font-size: 0.17rem;font-weight: bold;overflow: hidden; text-overflow: ellipsis; }
        .mission-item-detail {font-size: 0.13rem;line-height: 1.2;margin-top: 0.05rem;opacity: 0.8;}
        .mission-item-reward { display: flex; justify-content: center;line-height: 1; margin-top: 0.02rem;margin-bottom: 0.06rem; }
        .reward-icon { width: 0.12rem; height: 0.22rem; background-image: url(#{$path}/home/reward-icon.png); @include singleBg; }
        .reward-num { font-size: 0.2rem; margin: 0 0.05rem;color: #fff; }
        .mission-btn-box { width: 0.6rem; }
        .mission-btn { width: 0.6rem; height: 0.3rem; border-radius: 0.2rem;font-size: 0.12rem;line-height: 0.3rem;font-weight: bold;}
        .btn-todo { background-image: linear-gradient(0deg, #FFDE00 0%, #FFF8D3 100%);
            box-shadow: 0 0.02rem 0.08rem 0 rgba(0, 6, 181, 0.50);color: #311bdf;
            &:active {opacity: 0.7}
            }
        .btn-get-reward { background-image: linear-gradient(180deg, #FF5A88 0%, #FF1951 100%);
            box-shadow: 0 0.02rem 0.08rem 0 rgba(0, 6, 196, 0.50);color: #fff;}
        .btn-finish {background-color: rgba(255, 255, 255, 0.15);color: #fff; }
        }
    @keyframes panelShow {
        0% { transform: translateY(100%) }
        100% { transform: translateY(0) }
        }
    @keyframes panelHide {
        0% { transform: translateY(0) }
        100% { transform: translateY(100%) }
        }

</style>
<script type="javascript">
    import BScroll from 'better-scroll';
    import proHub from './../scripts/proHub';
    import Global from './../scripts/Global'

    export default {
        data() {
            return {
                isShow: true,
                ajaxPending: false,
                missionList: []
            }
        },
        mounted() {
            
            this.getqueryGooseTaskList();
        },
        methods: {
            
            getqueryGooseTaskList(){
                
                // 1.1.0 新增首页防刷功能
                let signData = {
                    channelLv: Global.channelLv||"ttte",
                    environment: Global.currentSystem||"jrApp",
                    riskDeviceInfo: Global.riskDeviceInfo, //`{\"eid\":\"${Global.riskDeviceInfo}\"}`,
                };
                let parameters = {
                    qdPageId: 'A05R',
                    mdClickId: 'A05R|clk_task',
                    pageUrl: window.location.href,
                    urlKey: window.location.origin + window.location.pathname,
                    isSlider:0,
                    };
                
                proHub.get('queryGooseTaskList', {
                    riskDeviceInfo: Global.riskDeviceInfo,
                    parameters: parameters,
                    channelLv: Global.channelLv||"ttte",
                    environment: Global.currentSystem||"jrApp",
                    signData: signData,
                    sign: true,
                }, (e) => {
                    if (e.code == '0000') {
                        //e.data[0].status = 1
                        this.missionList = e.data;
                    }
                });
                this.$nextTick(() => {
                    this.scroll = new BScroll(this.$refs.wrapper, {tap: true,click:true})
                })
            },

            finishLoading() {

            },
            panelHide() {
                this.isShow = false;
                setTimeout(() => {
                    this.$emit('panel-hide');
                }, 300)
            },
            hideAndJumpUrl(doLink){
                this.isShow = false;
                this.$emit('panel-hide');
                setTimeout(() => {
                    this.$jumpUrl(doLink)
                    // window.location.href = doLink
                }, 100);
            },
            jumpUrl(id, doLink) {
                if (id == 451) {
                    this.shareMission();
                } else {
                    this.hideAndJumpUrl(doLink)
                }
            },
            getMissionAndJump(id, doLink,missionType) {
                if (this.ajaxPending) return;
                this.getreceiveGooseTask(id,doLink,missionType);
                
            },

            getreceiveGooseTask(id,doLink,missionType){
                // 1.1.0 新增首页防刷功能
                let signData = {
                    channelLv: Global.channelLv||"ttte",
                    environment: Global.currentSystem||"jrApp",
                    riskDeviceInfo: Global.riskDeviceInfo, //`{\"eid\":\"${Global.riskDeviceInfo}\"}`,
                    shareUuid: Global.inviteId||"uuid",
                };
                let parameters = {
                    qdPageId: 'A05R',
                    mdClickId: 'A05R|clk_taskpage',
                    pageUrl: window.location.href,
                    urlKey: window.location.origin + window.location.pathname,
                    isSlider:0,
                    };
               
                this.ajaxPending = true;
                proHub.get('receiveGooseTask', {
                    missionType: missionType, 
                    missionId: '' + id, 
                    shareUuid: Global.inviteId||"uuid",
                    riskDeviceInfo: Global.riskDeviceInfo,
                    parameters: parameters,
                    channelLv: Global.channelLv||"ttte",
                    environment: Global.currentSystem||"jrApp",
                    signData: signData,
                    sign: true,
                }, (e) => {
                    if (e.code == '0000') {
                        if (id == 451) {
                            this.shareMission();
                        } else {
                            this.hideAndJumpUrl(doLink)
                        }
                    } else {
                        this.$emit('code-error', e.code)
                    }
                    this.ajaxPending = false;
                })
            },
        
            shareMission() {
                this.$emit('show-goldorder');
                this.panelHide();
            },
            getReward(id, rewardNum, index,missionType) {
                if(!id) return;
                if (this.ajaxPending) return;
                this.ajaxPending = true;
                this.getreceiveGooseTaskReward(id,rewardNum, index,missionType);
               
            },
            getReward2(missionType,doLinkAward) {
                // 小金库任务已经奖后 点击跳转小金库
                if(missionType==2) {
                    this.hideAndJumpUrl(doLinkAward||'https://lc.jr.jd.com/ck/xjkHold/index/?channel=a01345&channelToken=5694f89b803bfec731e515df4dbb937c')
                }
            },
            getreceiveGooseTaskReward(id,rewardNum, index,missionType){

                // 1.1.0 新增首页防刷功能
                let signData = {
                    channelLv: Global.channelLv||"ttte",
                    environment: Global.currentSystem||"jrApp",
                    riskDeviceInfo: Global.riskDeviceInfo
                };
                let parameters = {
                    qdPageId: 'A05R',
                    mdClickId: 'A05R|101448',
                    pageUrl: window.location.href,
                    urlKey: window.location.origin + window.location.pathname,
                    isSlider:0,
                    };
               
                proHub.get('receiveGooseTaskReward', {
                    missionType: missionType,
                    missionId: '' + id,
                    riskDeviceInfo: Global.riskDeviceInfo,
                    parameters: parameters,
                    channelLv: Global.channelLv||"ttte",
                    environment: Global.currentSystem||"jrApp",
                    signData: signData,
                    sign: true,
                }, (e) => {
                    if (e.code == '0000') {
                        this.$emit('get-reward', rewardNum);
                        this.missionList[index].status = 2;
                        // if(missionType==2){
                        //     // 小金库任务领取成功
                        //     window.localStorage.setItem('MISSION_FLAG','showed')
                        // }
                    } else {
                        this.$emit('code-error', e.code)
                    }
                    this.ajaxPending = false;
                })
            },

        }
    }
</script>
